import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueCookies from 'vue-cookies';
import { LayoutPlugin, BFormInput, BForm, BButton, BFormGroup, BLink } from 'bootstrap-vue'
import App from './App.vue'

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEye } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons/faEyeSlash";

import VueDrift from 'vue-drift'

import Hotjar from 'vue-hotjar'

// As a plugin
//import VueMask from 'v-mask'
Vue.config.productionTip = false

import '@/assets/scss/app.scss'

Vue.use(Vuelidate)
Vue.use(VueCookies);
Vue.use(LayoutPlugin);
Vue.component('b-form', BForm)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-input', BFormInput)
Vue.component('b-button', BButton)
Vue.component('b-link', BLink)

library.add(faEye, faEyeSlash)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueDrift, {
  appId: 'r8th29p44it6',
})

Vue.use (Hotjar, {
  id: process.env.VUE_APP_HOTJAR_ID // Hotjar Site ID
})

new Vue({
  Vuelidate,
  render: h => h(App),
}).$mount('#app')
